import React from 'react';

const Inventory = () => {
  return (
    <div className="card shadow-sm rounded-3 p-4">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="fw-bold">Inventory</h2>
          <p className="text-muted mb-0">Manage your inventory levels and stock tracking</p>
        </div>
        <button className="btn btn-primary">
          + Add Inventory Item
        </button>
      </div>

      {/* Stats Cards */}
      <div className="row mb-4">
        <div className="col-md-3">
          <div className="card shadow-sm p-3">
            <p className="text-muted small mb-1">Total Items</p>
            <h4>0</h4>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card shadow-sm p-3">
            <p className="text-muted small mb-1">Low Stock Items</p>
            <h4>0</h4>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card shadow-sm p-3">
            <p className="text-muted small mb-1">Out of Stock</p>
            <h4>0</h4>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card shadow-sm p-3">
            <p className="text-muted small mb-1">Total Value</p>
            <h4>€0.00</h4>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="d-flex align-items-center justify-content-center" style={{ height: '400px' }}>
        <div className="text-center">
          <h3 className="text-muted">Inventory Management</h3>
          <p className="text-muted">This section is under development</p>
          <p className="text-muted small">Track stock levels, manage inventory, and monitor product availability.</p>
        </div>
      </div>
    </div>
  );
};

export default Inventory;
